<template>
  <b-modal class="modal-lg" size="md" :id="addCustomerUserModal.id" :title="addCustomerUserModal.title" :header-bg-variant="'secondary'" hide-backdrop @show="clearData" @hide="resetModal">
    <template slot="modal-header" slot-scope="{ close }">
      <h5 class="modal-title text-light">{{ addCustomerUserModal.title }}</h5>
      <button aria-label="Close" class="close" data-dismiss="modal" type="button" @click="close()"><span aria-hidden="true" class="text-light">x</span></button>
    </template>
    <template slot="default">
      <div v-if="!getCustomerUserExists" class="row modal-body-log">
        <b-form-group class="mt-3 col-lg-12 col-sm-12 padding-fix">
          <b-input-group class="py-2">
            <b-input-group-prepend class="col-lg-5 col-sm-6 p-0">
              <b-input-group-text slot="prepend" class="col-12 pretext"><span class="pretext-span">{{ t('accountNumberLabelText', 'accountNumberLabelText') }}</span></b-input-group-text>
            </b-input-group-prepend>
            <b-form-input id="account_number" v-model="addCustomerUserModal.accountNumber" disabled></b-form-input>
          </b-input-group>
          <b-input-group class="py-2">
            <b-input-group-prepend class="col-lg-5 col-sm-6 p-0">
              <b-input-group-text slot="prepend" class="col-12 pretext"><span class="pretext-span">{{ t('realNameLabelText', 'realNameLabelText') }}</span></b-input-group-text>
            </b-input-group-prepend>
            <b-form-input id="real_name" v-model="addValues.name"></b-form-input>
          </b-input-group>
          <b-input-group class="py-2">
            <b-input-group-prepend class="col-lg-5 col-sm-6 p-0">
              <b-input-group-text slot="prepend" class="col-12 pretext"><span class="pretext-span">{{ t('emailLabelText', 'emailLabelText') }}</span></b-input-group-text>
            </b-input-group-prepend>
            <b-form-input id="email_address" v-model="addValues.email"></b-form-input>
          </b-input-group>
          <b-input-group class="py-2">
            <b-input-group-prepend class="col-lg-5 col-sm-6 p-0">
              <b-input-group-text slot="prepend" class="col-12 pretext"><span class="pretext-span">{{ t('passwordLabelText', 'passwordLabelText') }}</span></b-input-group-text>
            </b-input-group-prepend>
            <b-form-input id="user_password" v-model="addValues.password" :type="'password'"></b-form-input>
          </b-input-group>
          <b-input-group class="py-2">
            <b-input-group-prepend class="col-lg-5 col-sm-6 p-0">
              <b-input-group-text slot="prepend" class="col-12 pretext"><span class="pretext-span">{{ t('headUserLabelText', 'headUserLabelText') }}</span></b-input-group-text>
            </b-input-group-prepend>
            <b-form-select v-model="addValues.headUser" :options="headUserOptions" value-field="value" text-field="text"></b-form-select>
          </b-input-group>
          <b-input-group class="py-2" v-if="getCustomerUserDeliveryOptions.protectedUserEnabled && getCustomerUserDeliveryOptions.protectedUserEnabled == '1'">
            <b-input-group-prepend class="col-lg-5 col-sm-6 p-0">
              <b-input-group-text slot="prepend" class="col-12 pretext"><span class="pretext-span">{{ t('protectedUserLabelText', 'protectedUserLabelText') }}</span></b-input-group-text>
            </b-input-group-prepend>
            <div class="p-2">
              <b-form-checkbox v-model="addValues.protectedUser" :value="1" :unchecked-value="0"></b-form-checkbox>
            </div>
          </b-input-group>
        </b-form-group>
        <div class="col-lg-12 py-1">
          <span class="pretext-span tips-font-size">{{ t('addCustomerUserTempPassText', 'addCustomerUserTempPassText') }}</span>
        </div>
      </div>
      <div v-else class="row modal-body-log">
        <div class="col-lg-12 py-1">
          <span class="pretext-span tips-font-size">{{ t('addExistingUsertoCustomerQuestion', 'addExistingUsertoCustomerQuestion') }}</span>
        </div>
      </div>
    </template>
    <template slot="modal-footer" slot-scope="{ close }">
      <div v-if="!getCustomerUserExists">
        <button type="button" class="btn btn-secondary" @click="close()">{{t('cancelButtonText', 'cancelButtonText')}}</button>
        <button type="button" class="ml-2 btn btn-primary" :disabled="!addValues.email" @click="addCustomerUser()">{{t('addButtonText', 'addButtonText')}}</button>
      </div>
      <div v-else>
        <button type="button" class="btn btn-secondary" @click="close()">{{t('cancelButtonText', 'cancelButtonText')}}</button>
        <button type="button" class="ml-2 btn btn-primary" @click="addCustomerUser()">{{t('oKButtonText', 'oKButtonText')}}</button>
      </div>
    </template>
    <ValidationErrors class="p-1" v-if="getValidationErrors.validationName == 'customerUserError'"></ValidationErrors>
  </b-modal>
</template>

<script>
import { mapGetters } from 'vuex'
import ResponseInfo from '@/components/ResponseInfo.vue'
import ValidationErrors from '@/components/ValidationErrors.vue'

export default {
  name: 'ModalAddCustomerUser',
  components:{
    ResponseInfo,
    ValidationErrors
  },
  data () {
    return {
      addCustomerUserModal:{},
      headUserOptions: [
        { value: 0, text: 'no'},
        { value: 1, text: 'yes'}
      ],
      addValues: {
        name: '',
        email: '',
        password: null,
        protectedUser: 0,
        headUser: 0
      }
    }
  },
  computed:{
    ...mapGetters(['getResponseInfo', 'getUserDetails', 'getValidationErrors']),
    ...mapGetters('manageCustomersStore', ['getCustomerUserExists', 'getGeneralDeliveryOptions', 'getCustomerUserDeliveryOptions']),
  },
  methods: {
    resetModal() {
     this.$emit('hide')
    },
    clearData() {
      this.addValues = {
        name: '',
        email: '',
        password: null,
        protectedUser: 0,
        headUser: 0
      }
    },
    addCustomerUser() {
      this.$store.dispatch('alertClearResponse')
      this.$store.commit('alertClearErrors', null) //NS-9873 SP
      this.$store.dispatch('manageCustomersStore/addCustomerUserDeliveryOptions', {
        customerId: this.addCustomerUserModal.customerId,
        realName: this.addValues.name,
        email: this.addValues.email,
        password: this.addValues.password,
        headUser: this.addValues.headUser,
        protectedUser: this.addValues.protectedUser,
        currentUserId: this.getUserDetails.id,
        existingUser: this.getCustomerUserExists
      }).then(() => {
        //NS-9873 SP If user exists dont close modal
        if(!this.getCustomerUserExists) {
          if(Object.keys(this.getValidationErrors).length === 0) {
            this.$root.$emit('bv::hide::modal', this.addCustomerUserModal.id)
            this.resetModal();
          }
        }
      })
    },
  },
  created() {
		this.addCustomerUserModal = this.$attrs.modal
  },
}
</script>

<style scoped>

</style>